componentRegistryInstance.register('select1', 'edit', 'hrd.components.form.Select1Component');

hrd.components.form.Select1Component = hrd.components.form.AbstractSelectLikeComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.Select1Component',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditFieldInner: function(field, id, klass) {
		let options = field.data('extra-options') || {};
		var provider = this.getProvider(field);
		if (provider) {
			hrd.utils.buildSelect(field, provider, {
				keyProperty: field.data('key-property'),
				labelProperty: this.getLabelProvider(field),
				alternateProperty: field.data('alt-property'),
				keepLabelCase: field.data('keep-label-case') || false,
				initialValue: field.data('default') != undefined ? field.data('default') : null,
				noSort: !!(field.data('no-sort')),
				emptyList: !!(field.data('empty-list')),
				keepList: !!(field.data('keep-list')),
				keepProviderData: !!(field.data('keep-data')),
				extraArgs: this.getExtraArgs(field, options.forceToObject),
				optionExtraData: field.data('optionExtraData') ? field.data('optionExtraData').split(/[\s,]+/) : [],
				onChange: this.getOnChangeFn(field),
				ignoreIsSelectedAttribute: !!(field.data('ignoreIsSelectedAttribute'))
			});
		}
		/* registering the created promise into this.ENHANCE_PHASE_PROMISES array */
		var selectProviderPromise = field.data('loaded');
		if (selectProviderPromise) {
			this.addEnhancePhasePromise(selectProviderPromise);
			const skipNice = (typeof provider === 'function') || true; //??? TODO: fixme
			if (field.data('appearance') === 'nice' || !skipNice) {
				selectProviderPromise.then(() => {
					if(field.usingChromaFlow()) {
						const template = this.settings.reference[field.data('template-row')];
						const created = this.settings.reference[`${field.data('template-row')}Created`];
						const $form = this.toolbox.get('formInstance.$form', this.settings);

						const $newField = field.toSelectMinimal({
							template: template ? template.bind(this.settings.reference) : (rowData) => rowData && rowData[field.data('label-property')] ? rowData[field.data('label-property')] : '',
							templateCreated: created ? created.bind(this.settings.reference) : () => {},
							formElement: $form.exists() ? $form.get(0) : null
						});

						if($newField.usingChromaFlow()) {
							$.timeout(0)
								.then(() => {
									this.wrapForSelectAddon($newField);
									this.wrapForGenericSelectAddon($newField);
								});
						}
					} else {
                        let parent = field.parent();
                        field.niceSelect();
                        let pw = parent.width();
                        let lw = parent.find('label').outerWidth();
                        let gap = 5;
                        let fw = pw - lw - gap;
                        parent.addClass('with-nice-select').find('.nice-select').outerWidth(fw);
					}
				})
			} else {
				const appearance = field.data('appearance');

				selectProviderPromise.then(() => {
					if (appearance === 'minimal') {
						const template = this.settings.reference[field.data('template-row')];
						const created = this.settings.reference[`${field.data('template-row')}Created`];
						const $form = this.toolbox.get('formInstance.$form', this.settings);

						const $newField = field.toSelectMinimal({
							template: template ? template.bind(this.settings.reference) : (rowData) => rowData && rowData[field.data('label-property')] ? rowData[field.data('label-property')] : '',
							templateCreated: created ? created.bind(this.settings.reference) : () => {},
							formElement: $form.exists() ? $form.get(0) : null
						});

						if($newField.usingChromaFlow()) {
							$.timeout(0)
								.then(() => {
									this.wrapForSelectAddon($newField);
									this.wrapForGenericSelectAddon($newField);
								});
						}
					} else {
						if(field.usingChromaFlow()) {
							$.timeout(0)
								.then(() => {
									this.wrapForSelectAddon(field);
									this.wrapForGenericSelectAddon(field);
								});
						}
					}
				});
			}
		}
	},

	getEditableField: function(field, name, object, options) {
		var $opt = $('option:selected', field);
		this.setValueByPath(object, `${name}Label`, $opt.text());
		this.setValueByPath(object, name, field.val());
		if ($opt.data() != undefined) {
			$.each($opt.data(), (k, v) => {
				if (k.indexOf('extra') == 0) {
					var p = k.substring(5);
					this.setValueByPath(object, name + p, v);
				}
			});
		}
	},

	setEditableField: function(field, value, object, options) {
		var loaded = field.data('loaded');
		if (loaded && loaded.then && loaded.state() === 'pending') {
			loaded.then(function() {
				field.val(value);
				field.removeData('loaded');
			});
		} else {
			field.val(value);
		}
	},

	resetEditableField: function(field, options) {
		field.val('');
		var emptyList = !!field.data('empty-list');
		if (emptyList) {
			field.removeOption(/./); // removes all options before start adding the new ones
		}
	},

	disableField: function(field, disable) {
		/* searh if exists a 'nice-select' */
		const $niceSelect = field.parent().find('.nice-select');
		if ($niceSelect.exists()) {
			$niceSelect.toggleClass('disabled', disable);
		}
		this._super(field, disable);
	},
	wrapForSelectAddon: function(field) {
		if(!field.usingChromaFlow()) return;

		let $addon = field.closest('.field-composite').find('[data-variants~="select-addon"]');
		if(!$addon.exists()) {
			// const offset = field.next() && field.next().exists() ? field.next().outerWidth(true) : 0;
			const offset = 0;
			field
				.after(`
					<button style="--offset: ${offset}px" data-variants="${field.parent().is('.field-composite-2x') ? 'large' : ''} icon select-addon" data-action="${field.data('name')}Addon" data-show-text="false" data-icon-primary="fas fa-chevron-down" ${field.data('reset') === 'exclude' ? 'data-reset="exclude"' : ''}>
					</button>
				`);
			$('[data-variants~="select-addon"]', field.closest('.field-composite'))
				.button()
				.button('option', 'icons', { primary: `f-icon fas fa-chevron-down` });

			$addon = field.closest('.field-composite').find('[data-variants~="select-addon"]');
		}

		if($addon.exists() && !$addon.closest('.select-addon-container').exists()) {
			$addon
				.add($addon.siblings(this.wrappableSelectors))
				.wrapAll('<div class="select-addon-container field-container"></div>');
		}
	}
});